import OwnerChat from './OwnerChat';
export default OwnerChat;